import { pathToRegexp } from 'path-to-regexp';

export const TEST_ONLY_ROUTES: RegExp[] = [
    pathToRegexp('en-ca/2024'),
    pathToRegexp('en-ca/casumoverse-var'),
    pathToRegexp('en-ca/casumoverse-var-2'),
    pathToRegexp('en-ca/home'),
    pathToRegexp('en-ca/home-test'),
    pathToRegexp('en-ca/join'),
    pathToRegexp('en-ca/landing/adsterra'),
    pathToRegexp('en-ca/landing/q2-casino-wo'),
    pathToRegexp('en-ca/landing/q3-casino-wo'),
    pathToRegexp('en-ca/landing/roulette-q4-2023'),
    pathToRegexp('en-ca/landing/slots-q4-2023'),
    pathToRegexp('en-ca/landing/tj'),
    pathToRegexp('en-ca/landing/welcome-offer-q4-2023'),
    pathToRegexp('en-ca/landing/xmas-prize-pool'),
    pathToRegexp('en-ca/live-casino-welcome-offer'),
    pathToRegexp('en-ca/march-madness-2022'),
    pathToRegexp('en-ca/perf-test-page'),
    pathToRegexp('en-ca/test-sports(.*)'),
    pathToRegexp('en-ca/verse'),
    pathToRegexp('en-ca/welcome-offer'),
    pathToRegexp('en-gb/2024'),
    pathToRegexp('en-gb/android-app-guide'),
    pathToRegexp('en-gb/casumoverse-var-2'),
    pathToRegexp('en-gb/casumoverse-var2'),
    pathToRegexp('en-gb/home'),
    pathToRegexp('en-gb/home-test'),
    pathToRegexp('en-gb/jackpots'),
    pathToRegexp('en-gb/join'),
    pathToRegexp('en-gb/l/test'),
    pathToRegexp('en-gb/landing/q2-casino-wo'),
    pathToRegexp('en-gb/landing/q3-casino-wo'),
    pathToRegexp('en-gb/landing/xmas-prize-pool'),
    pathToRegexp('en-gb/live-casino-welcome-offer'),
    pathToRegexp('en-gb/lp/odds'),
    pathToRegexp('en-gb/lp/slots'),
    pathToRegexp('en-gb/perf-test-page'),
    pathToRegexp('en-gb/test-sports(.*)'),
    pathToRegexp('en-gb/verse'),
    pathToRegexp('en-gb/welcome-offer'),
    pathToRegexp('en-nz/2024'),
    pathToRegexp('en-nz/casumoverse-var'),
    pathToRegexp('en-nz/casumoverse-var-2'),
    pathToRegexp('en-nz/home'),
    pathToRegexp('en-nz/home-test'),
    pathToRegexp('en-nz/join'),
    pathToRegexp('en-nz/landing/prop'),
    pathToRegexp('en-nz/landing/q2-casino-wo'),
    pathToRegexp('en-nz/landing/q3-23-ps-book-of-dead'),
    pathToRegexp('en-nz/landing/q3-23-ps-casumo-jackpots'),
    pathToRegexp('en-nz/landing/q3-23-ps-mega-moolah'),
    pathToRegexp('en-nz/landing/q3-casino-wo'),
    pathToRegexp('en-nz/landing/tj'),
    pathToRegexp('en-nz/landing/xmas-prize-pool'),
    pathToRegexp('en-nz/perf-test-page'),
    pathToRegexp('en-nz/sports-welcome-offer'),
    pathToRegexp('en-nz/verse'),
    pathToRegexp('en-nz/welcome-offer'),
    pathToRegexp('en-nz/welcome-offer-smp'),
    pathToRegexp('en/2024'),
    pathToRegexp('en/casumoverse-var'),
    pathToRegexp('en/casumoverse-var-2'),
    pathToRegexp('en/danny'),
    pathToRegexp('en/home'),
    pathToRegexp('en/home-banner-test'),
    pathToRegexp('en/home-test'),
    pathToRegexp('en/jackpots'),
    pathToRegexp('en/join'),
    pathToRegexp('en/landing/casino-wo_b'),
    pathToRegexp('en/landing/q2-casino-wo'),
    pathToRegexp('en/landing/q3-casino-wo'),
    pathToRegexp('en/landing/xmas-prize-pool'),
    pathToRegexp('en/logged-in'),
    pathToRegexp('en/logged-in-out'),
    pathToRegexp('en/logged-in-slugified/:slug'),
    pathToRegexp('en/logged-out'),
    pathToRegexp('en/miguel-test/deposit'),
    pathToRegexp('en/perf-test-page'),
    pathToRegexp('en/testhomepage'),
    pathToRegexp('en/verse'),
    pathToRegexp('en/welcome-offer'),
    pathToRegexp('es/2024'),
    pathToRegexp('es/android-app-guide'),
    pathToRegexp('es/casumoverse-var-2'),
    pathToRegexp('es/casumoverse-var2'),
    pathToRegexp('es/home'),
    pathToRegexp('es/home-test'),
    pathToRegexp('es/join'),
    pathToRegexp('es/landing/q2-casino-wo'),
    pathToRegexp('es/landing/q3-casino-wo'),
    pathToRegexp('es/landing/xmas'),
    pathToRegexp('es/perf-test-page'),
    pathToRegexp('es/test-template/:mySlug'),
    pathToRegexp('es/verse'),
    pathToRegexp('fi/2024'),
    pathToRegexp('fi/casumoverse-var-2'),
    pathToRegexp('fi/casumoverse-var2'),
    pathToRegexp('fi/home'),
    pathToRegexp('fi/home-test'),
    pathToRegexp('fi/join'),
    pathToRegexp('fi/landing/prop'),
    pathToRegexp('fi/landing/tj'),
    pathToRegexp('fi/landing/xmas-prize-pool'),
    pathToRegexp('fi/perf-test-page'),
    pathToRegexp('fi/verse'),
    pathToRegexp('ie/2024'),
    pathToRegexp('ie/android-app-guide'),
    pathToRegexp('ie/casumoverse-var-2'),
    pathToRegexp('ie/casumoverse-var2'),
    pathToRegexp('ie/home'),
    pathToRegexp('ie/home-test'),
    pathToRegexp('ie/jackpots'),
    pathToRegexp('ie/join'),
    pathToRegexp('ie/landing/q2-casino-wo'),
    pathToRegexp('ie/landing/q3-casino-wo'),
    pathToRegexp('ie/landing/xmas-prize-pool'),
    pathToRegexp('ie/lp/odds'),
    pathToRegexp('ie/lp/slots'),
    pathToRegexp('ie/perf-test-page'),
    pathToRegexp('ie/test-new-casino'),
    pathToRegexp('ie/welcome-offer'),
    pathToRegexp('no/2024'),
    pathToRegexp('no/casumoverse-var-2'),
    pathToRegexp('no/casumoverse-var2'),
    pathToRegexp('no/home'),
    pathToRegexp('no/home-test'),
    pathToRegexp('no/jackpots'),
    pathToRegexp('no/join'),
    pathToRegexp('no/landing/prop'),
    pathToRegexp('no/landing/tj'),
    pathToRegexp('no/landing/xmas-prize-pool'),
    pathToRegexp('no/perf-test-page'),
    pathToRegexp('no/verse'),
    pathToRegexp('no/welcome-offer'),
    pathToRegexp('on/2024'),
    pathToRegexp('on/casumoverse-var-2'),
    pathToRegexp('on/casumoverse-var2'),
    pathToRegexp('on/home'),
    pathToRegexp('on/home-test'),
    pathToRegexp('on/join'),
    pathToRegexp('on/landing/adsterra'),
    pathToRegexp('on/landing/q2-casino-wo'),
    pathToRegexp('on/landing/q3-casino-wo'),
    pathToRegexp('on/landing/roulette-q4-2023'),
    pathToRegexp('on/landing/slots-q4-2023'),
    pathToRegexp('on/landing/tj'),
    pathToRegexp('on/landing/welcome-offer-q4-2023'),
    pathToRegexp('on/landing/xmas-prize-pool'),
    pathToRegexp('on/welcome-offer'),
    pathToRegexp('rog/2024'),
    pathToRegexp('rog/casino-riina'),
    pathToRegexp('rog/casumoverse-var-2'),
    pathToRegexp('rog/casumoverse-var2'),
    pathToRegexp('rog/home'),
    pathToRegexp('rog/join'),
    pathToRegexp('rog/perf-test-page'),
    pathToRegexp('row/2024'),
    pathToRegexp('row/casumoverse-var-2'),
    pathToRegexp('row/casumoverse-var2'),
    pathToRegexp('row/home'),
    pathToRegexp('row/home-test'),
    pathToRegexp('row/jackpots'),
    pathToRegexp('row/join'),
    pathToRegexp('row/landing/q2-casino-wo'),
    pathToRegexp('row/landing/q3-casino-wo'),
    pathToRegexp('row/landing/xmas-prize-pool'),
    pathToRegexp('row/perf-test-page'),
    pathToRegexp('row/verse'),
    pathToRegexp('row/welcome-offer'),
    pathToRegexp('sv/2024'),
    pathToRegexp('sv/android-app-guide'),
    pathToRegexp('sv/casumoverse-var-2'),
    pathToRegexp('sv/casumoverse-var2'),
    pathToRegexp('sv/home'),
    pathToRegexp('sv/home-test'),
    pathToRegexp('sv/jackpots'),
    pathToRegexp('sv/join'),
    pathToRegexp('sv/landing/q2-casino-wo'),
    pathToRegexp('sv/landing/q3-casino-wo'),
    pathToRegexp('sv/lp/odds'),
    pathToRegexp('sv/lp/slots'),
    pathToRegexp('sv/perf-test-page'),
    pathToRegexp('sv/verse'),
    pathToRegexp('sv/welcome-offer')
] as const;
